import axios from "../axiosConfig";

class Routes {
    getAllGroups = () => {
        let data = axios.get("/api/group/get");
        return data;
    };
    // updateGroup = (id) => {
    //     let data = axios.put("/api/group/update", id);
    //     return data;
    // };
    updateGroup = (id, data) => {
        return axios.put(`/api/group/update/${id}`, data);
    };
    createGroup = (val) => {
        let data = axios.post("/api/group/create", val)
        return data;
    };
    deleteGroup = (id) => {
        const data = axios.delete(`/api/group/delete/${id}`)
        return data
    };
    addGroupUser = (val) => {
        const data = axios.post("/api/group/add-users", val)
        return data
    }
    getGroupUserById = (id) => {
        let data = axios.get(`/api/group/get-users/${id}`);
        return data;
    };
    removeGroupUser = (val) => {
        const data = axios.delete("/api/group/remove-users", val)
        return data
    }
    getProjectById = (id) => {
        let data = axios.get(`/api/projects/get-projects-in-group/${id}`);
        return data;
    };
    projectAssignToGroup = (val) => {
        const data = axios.post("/api/projects/assign-project-to-group", val)
        return data
    }
    getGroupsByUser = (id) => {
        let data = axios.get(`/api/user/get-groups/${id}`);
        return data;
    }



}



export default new Routes();
